var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "report" },
    [
      !_vm.isDataLoaded
        ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
        : _vm.hasError
        ? _c("div", { staticClass: "error-container mt-2 ml-2 mb-3" }, [
            _c(
              "div",
              { staticClass: "error-icon mr-5" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-3x",
                  attrs: { icon: ["fas", "exclamation-triangle"] },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "error-content" }, [
              _c("h2", [_vm._v(" " + _vm._s(_vm.$t("generalError")))]),
            ]),
          ])
        : _c("div", { staticClass: "flex-container dark-text mb-1 pl-1" }, [
            _c(
              "div",
              { staticClass: "flex-col flex-1" },
              [
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _c("div", { staticClass: "flex-col flex-16" }, [
                    _c("div", { staticClass: "flex-row flex-1 asset-name" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-1 rotate left-vertical-bar boxborder mr-1 mb-1",
                          class: { "grey-bg": _vm.isNewUi },
                        },
                        [
                          _vm.isDataLoaded
                            ? _c(
                                "div",
                                { staticClass: "flex-row rotate-asset" },
                                [_vm._v(_vm._s(_vm.assetName))]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                          class: { "no-pad": _vm.isNewUi },
                        },
                        [
                          _c("report-box-new", {
                            attrs: { isNewUi: _vm.isNewUi },
                            on: {
                              "size-change": function ($event) {
                                return _vm.expandClicked(1)
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "commercialAndSustainabilityAsessment"
                                        )
                                      )
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "new-ui-csa-container": _vm.isNewUi,
                                        },
                                      },
                                      [
                                        _vm.isDataLoaded &&
                                        _vm.isNewUi &&
                                        _vm.currentModalId != 1
                                          ? _c(
                                              "CommercialAndSustainabilityNew",
                                              {
                                                attrs: {
                                                  serialNumber:
                                                    _vm.serialNumber,
                                                  csaDataProp: _vm.csaData,
                                                  csaLabels: _vm.csaLabels,
                                                },
                                              }
                                            )
                                          : _vm._e(),
                                        _vm.isDataLoaded && !_vm.isNewUi
                                          ? _c("CommercialAndSustainability", {
                                              attrs: {
                                                csaData: _vm.csaData,
                                                csaLabels: _vm.csaLabels,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex-row flex-1 strategy-cluster" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-col flex-1 left-vertical-bar boxborder mr-1 mb-1",
                            class: { "grey-bg": _vm.isNewUi },
                          },
                          [
                            _vm.isDataLoaded
                              ? _c("StrategyCluster", {
                                  attrs: { isInTarget: _vm.isInTarget },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                            class: { "no-pad": _vm.isNewUi },
                          },
                          [
                            _c("report-box-new", {
                              staticClass: "report-content",
                              attrs: { isNewUi: _vm.isNewUi },
                              on: {
                                "size-change": function ($event) {
                                  return _vm.expandClicked(2)
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        _vm._s(_vm.$t("performamceAssessment"))
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _vm.isDataLoaded &&
                                      _vm.currentModalId != 2
                                        ? _c("PerformanceAssessment", {
                                            attrs: {
                                              serialNumber: _vm.serialNumber,
                                              asset: _vm.asset,
                                              isNewUi: _vm.isNewUi,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "flex-row flex-1 sign-off" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-1 left-vertical-bar boxborder mr-1 mb-1",
                          class: { "grey-bg": _vm.isNewUi },
                          on: {
                            click: function ($event) {
                              return _vm.editDateRibbon()
                            },
                          },
                        },
                        [
                          _c("SignOff", {
                            attrs: {
                              isNewUi: _vm.isNewUi,
                              asset: _vm.asset,
                              openModal: _vm.isDateRibbonEdtitable,
                              serialNumber: _vm.serialNumber,
                            },
                            on: { "close-modal": _vm.closeDateRibbon },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                          class: { "no-pad": _vm.isNewUi },
                        },
                        [
                          _c("report-box-new", {
                            attrs: { isNewUi: _vm.isNewUi },
                            on: {
                              "size-change": function ($event) {
                                return _vm.expandClicked(3)
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "title",
                                fn: function () {
                                  return [_vm._v(_vm._s(_vm.$t("dates")))]
                                },
                                proxy: true,
                              },
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _vm.isDataLoaded
                                      ? _c("Dates", {
                                          attrs: {
                                            datesGeneralStrategyobj:
                                              _vm.datesGeneralStrategyobj,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-col flex-16" }, [
                    _c(
                      "div",
                      { staticClass: "flex-row flex-1 strategic-eol" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                            class: { "no-pad": _vm.isNewUi },
                          },
                          [
                            _c("report-box-new", {
                              attrs: { isNewUi: _vm.isNewUi },
                              on: {
                                "size-change": function ($event) {
                                  return _vm.expandClicked(4)
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _vm.isDataLoaded
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.$t("generalStrategy"))
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _vm.isDataLoaded
                                        ? _c("GeneralStrategy", {
                                            attrs: {
                                              genStat:
                                                _vm.datesGeneralStrategyobj,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "flex-col flex-1 boxborder mr-1 mb-1",
                            class: { "no-shadow": _vm.isNewUi },
                          },
                          [
                            _vm.isDataLoaded
                              ? _c("VerticalRibbon", {
                                  attrs: {
                                    isNewUi: _vm.isNewUi,
                                    ribbonText: "Strategic EOL",
                                    ribbonValue:
                                      _vm.datesGeneralStrategyobj
                                        .strategyEolValue,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex-row flex-1 eas-asset-cluster" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                            class: { "no-pad": _vm.isNewUi },
                          },
                          [
                            _c("report-box-new", {
                              attrs: { isNewUi: _vm.isNewUi },
                              on: {
                                "size-change": function ($event) {
                                  return _vm.expandClicked(5)
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("maintenanceAndRiskProcesses")
                                        )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _vm.isDataLoaded
                                        ? _c("MentenanceAndRisk", {
                                            attrs: {
                                              isNewUi: _vm.isNewUi,
                                              mrp: _vm.mrp,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "flex-col flex-1 boxborder mr-1 mb-1",
                            class: { "no-shadow": _vm.isNewUi },
                          },
                          [
                            _vm.isDataLoaded
                              ? _c("VerticalRibbon", {
                                  attrs: {
                                    ribbonText: _vm.isNuclearAsset
                                      ? _vm.$t("maintainenceCluster")
                                      : _vm.$t("easAssetCluster"),
                                    isNewUi: _vm.isNewUi,
                                    ribbonValue: _vm.decisionModelOutput,
                                    hasAction:
                                      _vm.isNewUi && _vm.mrp.showDecisionOutput,
                                    actionString: "asset cluster",
                                  },
                                  on: {
                                    "show-modal": function ($event) {
                                      return _vm.showStratFlagModal()
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex-row flex-1 aero-risk-life" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                            class: { "no-pad": _vm.isNewUi },
                          },
                          [
                            _c("report-box-new", {
                              attrs: { isNewUi: _vm.isNewUi },
                              on: {
                                "size-change": function ($event) {
                                  return _vm.expandClicked(6)
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("supportingAssetProcesses")
                                        )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _vm.isDataLoaded
                                        ? _c("SupportingAsset", {
                                            attrs: {
                                              sap: _vm.sap,
                                              isNewUi: _vm.isNewUi,
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "flex-col flex-1 boxborder mr-1 mb-1",
                            class: { "no-shadow": _vm.isNewUi },
                          },
                          [
                            _vm.isDataLoaded
                              ? _c("VerticalRibbon", {
                                  attrs: {
                                    isNewUi: _vm.isNewUi,
                                    ribbonText: _vm.isNuclearAsset
                                      ? _vm.$t("opportunitiesCluster")
                                      : _vm.$t("aeroRiskLife"),
                                    ribbonValue: _vm.isNuclearAsset
                                      ? _vm.sap.opportunitiesCluster
                                      : _vm.sap.aeroRiskLife,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    !_vm.isNewUi
                      ? _c(
                          "div",
                          { staticClass: "flex-row flex-1 am-process" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1",
                              },
                              [
                                _c("report-box-new", {
                                  attrs: { isNewUi: _vm.isNewUi },
                                  on: {
                                    "size-change": function ($event) {
                                      return _vm.expandClicked(7)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("amProcessOverview")
                                              )
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "content",
                                        fn: function () {
                                          return [
                                            _vm.isDataLoaded
                                              ? _c("AmProcess", {
                                                  attrs: {
                                                    decisionModelList:
                                                      _vm.ampData,
                                                    ampModel: _vm.ampModel,
                                                  },
                                                  on: {
                                                    newAMPData: _vm.onAMPSave,
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3589108724
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-col flex-1 rotate left-vertical-bar boxborder mr-1 mb-1",
                                class: { "grey-bg": _vm.isNewUi },
                              },
                              [
                                _c("div", { staticClass: "flex-row" }, [
                                  _c("span", { staticClass: "tooltip" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "tooltiptext",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                          },
                                        },
                                      },
                                      [
                                        _c("dt", [
                                          _vm._v(_vm._s(_vm.$t("cashFlow"))),
                                        ]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              this.strategicFlagComments
                                                .cashFlowsComment ||
                                                _vm.$t(
                                                  "cashflowCommentNotAvailable"
                                                )
                                            )
                                          ),
                                        ]),
                                        _c("br"),
                                        _c("dt", [
                                          _vm._v(
                                            _vm._s(_vm.$t("comment")) + ":"
                                          ),
                                        ]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              this.strategicFlagComments
                                                .strategicFlagValueComment ||
                                                _vm.$t(
                                                  "strategicFlagCommentNotAvailable"
                                                )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.ampModel
                                            .blockReleaseStrategicFlagValue
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm.isNewUi
                  ? _c("div", { staticClass: "flex-row flex-1 am-process" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-24 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1 no-pad",
                        },
                        [
                          _c("report-box-new", {
                            attrs: { isNewUi: _vm.isNewUi },
                            on: {
                              "size-change": function ($event) {
                                return _vm.expandClicked(7)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        _vm._s(_vm.$t("amProcessOverview"))
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _vm.isDataLoaded &&
                                      _vm.currentModalId != 7
                                        ? _c("AmProcessNew", {
                                            attrs: {
                                              serialNumber: _vm.serialNumber,
                                              ampModel: _vm.ampModel,
                                            },
                                            on: { newAMPData: _vm.onAMPSave },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4111261501
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-col flex-1 rotate boxborder mr-1 mb-1",
                          class: { "grey-bg": _vm.isNewUi },
                          on: {
                            click: function ($event) {
                              return _vm.editStrategicFlag()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "flex-row" }, [
                            _c("span", { staticClass: "tooltip" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "tooltiptext",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("dt", [
                                    _vm._v(_vm._s(_vm.$t("cashFlow")) + ":"),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        this.strategicFlagComments
                                          .cashFlowsComment ||
                                          _vm.$t("cashflowCommentNotAvailable")
                                      )
                                    ),
                                  ]),
                                  _c("br"),
                                  _c("dt", [
                                    _vm._v(_vm._s(_vm.$t("comment")) + ":"),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        this.strategicFlagComments
                                          .strategicFlagValueComment ||
                                          _vm.$t(
                                            "strategicFlagCommentNotAvailable"
                                          )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.ampModel.blockReleaseStrategicFlagValue
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._l(_vm.footerData, function (footer) {
                  return _c(
                    "div",
                    { key: footer.attributeTitle, staticClass: "flex-row" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-col report-footer pr-2 pl-1" },
                        [
                          _c("div", { staticClass: "uiText" }, [
                            _c("b", [_vm._v(_vm._s(footer.attributeTitle))]),
                            _vm._v(" " + _vm._s(footer.attributeText)),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
      _vm.isDataLoaded && _vm.shouldShowModal
        ? _c(
            "modal-box",
            {
              attrs: {
                open: _vm.isDataLoaded && _vm.shouldShowModal,
                width: "1080px",
              },
              domProps: {
                onClose: _vm.closeModal,
                enableHeader: true,
                enableFooter: false,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "modalHeader",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  !_vm.showStrategicFlagModal
                    ? _c(
                        "div",
                        { staticClass: "flex-row flex-1 modal-header" },
                        [
                          _c("div", { staticClass: "flex-col flex-1" }, [
                            _c("h3", [
                              _vm._v(
                                _vm._s(_vm.asset.name) +
                                  " - " +
                                  _vm._s(_vm.$t("decisionModelDetails"))
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "flex-row flex-1 modal-header" },
                        [
                          _c("div", { staticClass: "flex-col" }, [
                            _c("h3", [_vm._v(_vm._s(_vm.asset.name))]),
                          ]),
                          _c("span", {
                            staticClass: "separator ml-6 mr-4 mt-1",
                          }),
                          _c("div", { staticClass: "flex-col flex-1" }, [
                            _c("h3", [_vm._v(_vm._s(_vm.$t("strategicFlag")))]),
                          ]),
                        ]
                      ),
                ]
              ),
              _c("span", [
                !_vm.showStrategicFlagModal
                  ? _c("div", [
                      _c("div", { staticClass: "flex-row flex-1 link-bar" }, [
                        _c("div", { staticClass: "flex-col flex-1" }, [
                          _c(
                            "div",
                            { staticClass: "flex-row flex-1 link-bar-row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex-col link-box pl-1 pr-1 br",
                                  class: { active: _vm.activeTab === "cal" },
                                  on: { click: () => (_vm.activeTab = "cal") },
                                },
                                [_vm._v(_vm._s(_vm.$t("calculatedDecision")))]
                              ),
                              _vm.hasEditAccess
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-col link-box pl-1 pr-1",
                                      class: {
                                        active: _vm.activeTab === "mod",
                                      },
                                      on: {
                                        click: () => (_vm.activeTab = "mod"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("modifiedDecision")))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "flex-row flex-1" }, [
                        _c(
                          "div",
                          { staticClass: "flex-col flex-1" },
                          [
                            _vm.activeTab === "cal"
                              ? _c("decision-model-component", {
                                  attrs: { serialNumber: _vm.serialNumber },
                                })
                              : _vm._e(),
                            _vm.activeTab === "mod"
                              ? _c("decision-model-edit", {
                                  staticClass: "decision-output-edit",
                                  attrs: {
                                    decision: _vm.decisionModelOutput,
                                    serialNumber: _vm.serialNumber,
                                  },
                                  on: {
                                    "on-decision-output-change":
                                      _vm.onDecisionOutputSave,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "flex-col edit-comment" }, [
                        _c("div", { staticClass: "mt-3 ui-text" }, [
                          _c(
                            "label",
                            {
                              staticClass: "ui-text-label",
                              attrs: { for: "uiTextValue" },
                            },
                            [_vm._v(_vm._s(_vm.$t("value")))]
                          ),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.ampModel.blockReleaseStrategicFlagValue,
                                expression:
                                  "ampModel.blockReleaseStrategicFlagValue",
                              },
                            ],
                            staticClass: "ui-text-input",
                            attrs: {
                              id: "uiTextValue",
                              placeholder: _vm.$t("value"),
                              rows: "1",
                            },
                            domProps: {
                              value:
                                _vm.ampModel.blockReleaseStrategicFlagValue,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.ampModel,
                                  "blockReleaseStrategicFlagValue",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "mt-3 ui-text" }, [
                          _c(
                            "label",
                            {
                              staticClass: "ui-text-label",
                              attrs: { for: "uiTextValue" },
                            },
                            [_vm._v(_vm._s(_vm.$t("reason")))]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.strategicFlagUpdComment,
                                expression: "strategicFlagUpdComment",
                              },
                            ],
                            staticClass: "ui-text-input",
                            attrs: {
                              id: "uiTextValue",
                              placeholder: _vm.$t("reason"),
                            },
                            domProps: { value: _vm.strategicFlagUpdComment },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.strategicFlagUpdComment =
                                  $event.target.value
                              },
                            },
                          }),
                        ]),
                        _c(
                          "div",
                          { class: _vm.errorExists ? "error-text" : "" },
                          [
                            _vm.errorExists
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.$t("thisFieldIsMandatory"))
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _c("br"),
                      _c(
                        "div",
                        { staticClass: "flex-row reverse save-startegic" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-col flex-align-end" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn mt-1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveStrategicFlagValue()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.currentModalId > -1
        ? _c("report-modal", {
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "flex-row flex-1" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isPopUpInEditMode,
                                expression: "!isPopUpInEditMode",
                              },
                            ],
                            staticClass:
                              "flex-col flex-1 direction-arrow justify-center align-center mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.showPrevReportModal()
                              },
                            },
                          },
                          [_vm._v("<")]
                        ),
                        _c("div", { staticClass: "flex-col flex-14" }, [
                          _c(
                            "div",
                            { staticClass: "flex-row flex-1 asset-name" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-col flex-1 rotate left-vertical-bar boxborder mr-1 mb-1",
                                  class: { "grey-bg": _vm.isNewUi },
                                },
                                [
                                  _vm.isDataLoaded
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex-row rotate-asset",
                                        },
                                        [_vm._v(_vm._s(_vm.assetName))]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-col flex-11 boxborder mr-1 mb-1 pl-1 pt-1 pr-1 pb-1 no-pad",
                                },
                                [
                                  _c("report-box-new", {
                                    staticClass: "report-content",
                                    attrs: { isNewUi: true, isExpanded: true },
                                    on: {
                                      "size-change": function ($event) {
                                        return _vm.shrinkClicked()
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function () {
                                            return [
                                              _vm._v(_vm._s(_vm.modalTitle)),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "content",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "max-height": "45rem",
                                                    overflow: "auto",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    _vm.selectedComponent,
                                                    _vm._b(
                                                      { tag: "component" },
                                                      "component",
                                                      _vm.componentProperties,
                                                      false
                                                    )
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      892077086
                                    ),
                                  }),
                                  _c("div", { staticClass: "modal-footer" }, [
                                    _vm.isPopUpInEditMode
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary reset",
                                            on: {
                                              click: function ($event) {
                                                return _vm.resetEditedContent()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("reset")))]
                                        )
                                      : _vm._e(),
                                    _vm.hasModalEdit &&
                                    _vm.hasEditAccess &&
                                    !_vm.isPopUpInEditMode
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary ëdit",
                                            on: {
                                              click: function ($event) {
                                                return _vm.setEditMode()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("edit")))]
                                        )
                                      : _vm._e(),
                                    _vm.hasModalEdit &&
                                    _vm.hasEditAccess &&
                                    _vm.isPopUpInEditMode
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary ëdit",
                                            on: {
                                              click: function ($event) {
                                                return _vm.saveEditedContent()
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("save")))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-danger close",
                                        on: {
                                          click: function ($event) {
                                            _vm.isPopUpInEditMode
                                              ? _vm.cancelEdit()
                                              : _vm.shrinkClicked()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.closeButtonText) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isPopUpInEditMode,
                                expression: "!isPopUpInEditMode",
                              },
                            ],
                            staticClass:
                              "flex-col flex-1 direction-arrow justify-center align-center ml-2",
                            on: {
                              click: function ($event) {
                                return _vm.showNextReportModal()
                              },
                            },
                          },
                          [_vm._v(">")]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1268278440
            ),
          })
        : _vm._e(),
      _c("confirm-modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showConfirm,
            expression: "showConfirm",
          },
        ],
        attrs: {
          item: { sNo: this.serialNumber },
          message: "areYouSureToDiscardChanges",
        },
        on: {
          "confirm-action": _vm.callbackFunc,
          "cancel-action": () => (_vm.showConfirm = false),
        },
      }),
      _c("RunCalculation", {
        attrs: { asset: _vm.asset, serialNumber: _vm.serialNumber },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }